<template>
  <div class="GeneralCourse">
    <div class="SearchCourse">
      <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          width: 25%;
          height: 100%;
          border-right: 1px solid #c3c3c3;
          padding: 0 10px;
        "
      >
        <b-button
          class="BtnRegister"
          style="background: #0188c8"
          @click="handleModals('course')"
        >
          <b-icon-plus scale="1.5"></b-icon-plus>
          Novo Curso</b-button
        >
      </div>
      <div class="searchInput">
        <b-form-select
          class="searchFilter"
          size="sm"
          value-field="value"
          text-field="text"
          v-model="type"
          :options="filterCombobox"
        ></b-form-select>
        <b-input
          size="sm"
          placeholder="Pesquisar"
          v-model="textPesquisa"
          class="inputSearch"
          @keyup.enter="searchUser()"
        ></b-input>
        <b-button size="sm" @click="searchUser()" class="searchBtn">
          <b-icon-search></b-icon-search>
        </b-button>
        <div class="searchInputAll" style="justify-content: flex-end">
          <button class="searchAll" @click="readCourses()">ver tudo</button>
        </div>
      </div>
      <div style="width: 10%">
        <img class="books" :src="books" />
      </div>
    </div>
    <div>
      <div class="ContainerSearchInput">
        <div class="textRegister">
          <span>Cursos Registrados</span>
        </div>
        <label class="switch">
          <input type="checkbox" v-model="filterActive" />
          <span class="slider"></span>
        </label>
      </div>
      <div class="ContentTable" style="color: #3a4750; width: 100%">
        <div
          v-for="course in filteredCourses"
          :key="course.id"
          @click.stop="findById(course)"
          class="rowCLient"
        >
          <div class="celTable">
            <span class="textEllipsis">
              <div class="boollgreen" v-if="course.active"></div>
              <div class="boollred" v-else></div>
            </span>
          </div>
          <span
            class="notResult"
            :style="`width: 60px; height: 60px; background-image: url(${
              course.url || notImg
            }); background-repeat: no-repeat; background-size: contain; background-position: center center`"
          />
          <div class="celTable" style="width: 25%; min-width: 25%">
            <span class="textEllipsis">
              <strong>Nome: </strong>
              <strong
                style="
                  color: #0188c8;
                  font-weight: bold;
                  text-transform: uppercase;
                  padding-left: 3px;
                "
                >{{ course.name }}</strong
              >
            </span>
            <span class="textEllipsis"
              ><strong>Limite: </strong> {{ course.studantsLimit }}</span
            >
          </div>
          <div class="celTable" style="width: 55%">
            <span class="textEllipsisResize"
              ><strong style="padding-right: 5px">Descrição: </strong
              >{{ course.description }}</span
            >
          </div>
          <div class="celTable" style="width: 20%">
            <span
              class="textEllipsis"
              style="
                color: #0188c8;
                font-weight: bold;
                text-transform: uppercase;
              "
              ><strong>Valor: </strong
              >{{
                course.price.toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })
              }}</span
            >
            <span class="textEllipsis"
              ><strong>Parcelas: </strong>{{ course.qtdInstallments }} X
              {{
                course.pricingInstallments.toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })
              }}</span
            >
          </div>
          <div class="celTableActions">
            <div class="btnActions">
              <b-dropdown
                id="dropdown-1"
                class="btnActions1"
                variant="none"
                size="sm"
              >
                <template #button-content>
                  <b-icon-gear-fill class="contentActions"></b-icon-gear-fill>
                </template>

                <b-dropdown-item @click.stop="findById(course)">
                  Detalhes
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="!course.isStarting"
                  @click.stop="openDelete(course.id)"
                >
                  Excluir
                </b-dropdown-item>
                <!-- <b-dropdown-item
                  v-if="course.isStarting"
                  @click.stop="openProcess(course.id)"
                >
                  Finalizar curso
                </b-dropdown-item>
                <b-dropdown-item v-else @click.stop="openStart(course.id)">
                  Iniciar curso
                </b-dropdown-item> -->
                <b-dropdown-item
                  v-if="course.isStarting === true"
                  @click.stop="reinciarCurso(course.id)"
                >
                  Reiniciar curso
                </b-dropdown-item>
                <b-dropdown-item @click.stop="allStudentTheCourse(course.id)">
                  Alunos vinculados
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="course.active"
                  @click.stop="assignObjetcCourse(course)"
                >
                  Desativar Curso
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="!course.active"
                  @click.stop="active(course)"
                >
                  Ativar Curso
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
        </div>
      </div>
      <div v-if="spinGeneral" class="loadingLazy">
        <div class="loader"></div>
      </div>
      <b-modal id="modal-close1" hide-footer hide-header centered>
        <div>
          <div class="contentTitle">
            <h6 class="titleModalReversalOrDelete">Finalizar Curso</h6>
          </div>

          <section
            style="
              width: 100%;
              display: flex;
              flex-direction: column;
              align-items: flex-end;
              gap: 20px;
              margin-top: 20px;
              margin-bottom: 15px;
              padding: 0 10px;
            "
          >
            <div style="width: 100%">
              <p class="subTitle" style="margin: 0">
                O curso selecionado esta prestes a ser finalizado!
              </p>
            </div>

            <div style="width: 100%">
              <b-form-checkbox
                class="footerTitle"
                size="sm"
                id="checkbox-1"
                v-model="confirmProcess"
                name="checkbox-1"
              >
                Estou ciente e desejo finalizar.
              </b-form-checkbox>
            </div>

            <div class="rowContainer" style="width: 100%">
              <span>
                <b-icon-cloud-fill></b-icon-cloud-fill>Informe a Senha:</span
              >
              <div class="rowContent">
                <div class="input-group" style="width: 100%">
                  <input
                    type="password"
                    required
                    class="input borderInput"
                    v-model="comparePass"
                  />
                </div>
              </div>
            </div>
          </section>

          <div class="btnsModalActions">
            <button class="btnCancel" @click="$bvModal.hide('modal-close1')">
              Não
            </button>
            <button
              class="btnConfirm"
              @click="finishCourse"
              style="position: relative"
            >
              Sim, finalizar
              <span
                v-if="spinLoadingActionsButton"
                style="position: absolute; right: 5px"
                ><b-spinner small
              /></span>
            </button>
          </div>
        </div>
      </b-modal>
      <b-modal id="modal-start1" hide-footer hide-header centered>
        <div>
          <div class="contentTitle">
            <h6 class="titleModalReversalOrDelete">Iniciar Curso</h6>
          </div>

          <section
            style="
              width: 100%;
              display: flex;
              flex-direction: column;
              align-items: flex-end;
              gap: 20px;
              margin-top: 20px;
              margin-bottom: 15px;
              padding: 0 10px;
            "
          >
            <div style="width: 100%">
              <p class="subTitle" style="margin: 0">
                O curso selecionado esta prestes a ser iniciado!
              </p>
            </div>

            <div style="width: 100%">
              <b-form-checkbox
                class="footerTitle"
                size="sm"
                id="checkbox-1"
                v-model="confirmProcess"
                name="checkbox-1"
              >
                Estou ciente e desejo Iniciar.
              </b-form-checkbox>
            </div>

            <div class="rowContainer" style="width: 100%">
              <span>
                <b-icon-cloud-fill></b-icon-cloud-fill>Informe a Senha:</span
              >
              <div class="rowContent">
                <div class="input-group" style="width: 100%">
                  <input
                    required
                    type="password"
                    class="input borderInput"
                    v-model="comparePass"
                  />
                </div>
              </div>
            </div>
          </section>

          <div class="btnsModalActions">
            <button class="btnCancel" @click="$bvModal.hide('modal-start1')">
              Não
            </button>
            <button
              class="btnConfirm"
              @click="startCourse"
              style="position: relative"
            >
              Sim, Iniciar
              <span
                v-if="spinLoadingActionsButton"
                style="position: absolute; right: 5px"
                ><b-spinner small
              /></span>
            </button>
          </div>
        </div>
      </b-modal>
      <b-modal id="modal-restart" hide-footer hide-header centered>
        <div>
          <div class="contentTitle">
            <h6 class="titleModalReversalOrDelete">Reiniciar Curso</h6>
          </div>

          <section
            style="
              width: 100%;
              display: flex;
              flex-direction: column;
              align-items: flex-end;
              gap: 20px;
              margin-top: 20px;
              margin-bottom: 15px;
              padding: 0 10px;
            "
          >
            <div style="width: 100%">
              <p class="subTitle" style="margin: 0">
                O curso selecionado esta prestes a ser reiniciado!
              </p>
            </div>

            <div style="width: 100%">
              <b-form-checkbox
                class="footerTitle"
                size="sm"
                id="checkbox-1"
                v-model="confirmProcess"
                name="checkbox-1"
              >
                Estou ciente e desejo Reiniciar.
              </b-form-checkbox>
            </div>

            <div class="rowContainer" style="width: 100%">
              <span>
                <b-icon-cloud-fill></b-icon-cloud-fill>Informe a Senha:</span
              >
              <div class="rowContent">
                <div class="input-group" style="width: 100%">
                  <input
                    required
                    type="password"
                    class="input borderInput"
                    v-model="comparePass"
                  />
                </div>
              </div>
            </div>
          </section>

          <div class="btnsModalActions">
            <button class="btnCancel" @click="$bvModal.hide('modal-restart')">
              Não
            </button>
            <button
              class="btnConfirm"
              @click="reiniciarCurso"
              style="position: relative"
            >
              Sim, Iniciar
              <span
                v-if="spinLoadingActionsButton"
                style="position: absolute; right: 5px"
                ><b-spinner small
              /></span>
            </button>
          </div>
        </div>
      </b-modal>
      <b-modal id="modal-students" size="xl" hide-footer hide-header centered>
        <div>
          <div class="contentTitle">
            <h6 class="titleModalReversalOrDelete">Alunos Vinculados</h6>
          </div>
          <div class="ContentTable" style="color: #3a4750; width: 100%">
            <div
              v-for="students in allStudentsTheCourse"
              :key="students.id"
              class="rowCLient"
            >
              <span
                class="notResult"
                :style="`width: 50px; height: 50px; background-image: url(${notImg}); background-repeat: no-repeat; background-size: contain; background-position: center center`"
              />
              <div class="celTable" style="width: 25%; min-width: 25%">
                <span class="textEllipsis">
                  <strong>Nome: </strong>
                  <strong
                    style="
                      color: #403b74;
                      font-weight: bold;
                      text-transform: uppercase;
                      padding-left: 3px;
                    "
                    >{{ students.name }}</strong
                  >
                </span>
                <span class="textEllipsis">
                  <strong>CPF / RG : </strong>
                  {{ students.cpf }} / {{ students.rg }}
                </span>
              </div>
              <div class="celTable" style="width: 20%; min-width: 20%">
                <span
                  class="wtsTd textEllipsis"
                  @click.stop="redirectWhatsApp(students.phone)"
                >
                  <strong>Whatsapp: </strong>
                  {{ students.phone || "(00) 0000-0000" }}
                  <div v-if="students.phone">
                    <img class="whatsapp" :src="whatsapp" />
                  </div>
                </span>
                <span class="textEllipsis">
                  <strong>Email: </strong>
                  {{ students.email || "--" }}
                </span>
              </div>
              <div class="celTable" style="width: 30%; min-width: 30%">
                <span class="textEllipsis"
                  ><strong>Endereço: </strong>{{ students.address }} -
                  {{ students.district }} , {{ students.number || "S/N" }}</span
                >
                <span class="textEllipsis"
                  ><strong>Cidade: </strong>{{ students.city || "--" }}
                  {{ students.uf }}</span
                >
              </div>
            </div>
          </div>
          <div class="btnsModalActions">
            <b-button class="btnCan" @click="$bvModal.hide('modal-students')"
              >Fechar
            </b-button>
            <b-button class="btnsSave" @click="exportToExcel"
              >Exportar
            </b-button>
          </div>
        </div>
      </b-modal>
      <b-modal id="modal-excluir" hide-footer hide-header centered>
        <div>
          <div class="contentTitle">
            <h6 class="titleModalReversalOrDelete">Excluir</h6>
          </div>

          <section
            style="
              width: 100%;
              display: flex;
              flex-direction: column;
              align-items: flex-end;
              gap: 20px;
              margin-top: 20px;
              margin-bottom: 15px;
              padding: 0 10px;
            "
          >
            <div style="width: 100%">
              <p class="subTitle" style="margin: 0">
                O item selecionado esta prestes a ser excluido!
              </p>
            </div>

            <div style="width: 100%">
              <b-form-checkbox
                class="footerTitle"
                size="sm"
                id="checkbox-1"
                v-model="confirmDelete"
                name="checkbox-1"
              >
                Estou ciente e desejo excluir.
              </b-form-checkbox>
            </div>
          </section>

          <div class="btnsModalActions">
            <button class="btnCancel" @click="$bvModal.hide('modal-excluir')">
              Não
            </button>
            <button
              @click.stop="deleteCourse(stockId)"
              class="btnConfirm"
              style="position: relative"
            >
              Sim, excluir
              <span
                v-if="spinLoadingActionsButton"
                style="position: absolute; right: 5px"
                ><b-spinner small
              /></span>
            </button>
          </div>
        </div>
      </b-modal>
      <b-modal id="modal-active" hide-footer hide-header centered>
        <div>
          <div class="contentTitle">
            <h6 class="titleModalReversalOrDelete">Desativar Curso</h6>
          </div>

          <section
            style="
              width: 100%;
              display: flex;
              flex-direction: column;
              align-items: flex-end;
              gap: 20px;
              margin-top: 20px;
              margin-bottom: 15px;
              padding: 0 10px;
            "
          >
            <div style="width: 100%">
              <p class="subTitle" style="margin: 0">
                O curso selecionado esta prestes a ser desativado!
              </p>
            </div>

            <div style="width: 100%">
              <b-form-checkbox
                class="footerTitle"
                size="sm"
                id="checkbox-1"
                v-model="confirmDesabled"
                name="checkbox-1"
              >
                Estou ciente e desejo desativar esse curso.
              </b-form-checkbox>
            </div>
          </section>

          <div class="btnsModalActions">
            <button class="btnCancel" @click="$bvModal.hide('modal-active')">
              Não
            </button>
            <button
              @click.stop="disable()"
              class="btnConfirm"
              style="position: relative"
            >
              Sim, Desativar
              <span
                v-if="spinLoadingActionsButton"
                style="position: absolute; right: 5px"
                ><b-spinner small
              /></span>
            </button>
          </div>
        </div>
      </b-modal>
    </div>

    <div :class="sizeModalRegister">
      <div :class="modalContainer" v-if="colapseRegister">
        <b-button class="closeModalRegister" @click="modalHeight"> X </b-button>
        <Course
          class="cardContentModal"
          v-if="this.typeRegister.course"
          @getAllCourse="handleGetAllCourses($event)"
        />
      </div>
    </div>
  </div>
</template>
<script>
import Course from "../GeneralCourse/Course.vue";
import { mapMutations, mapState } from "vuex";
import books from "../../assets/books.svg";
import CourseService from "../../services/course";
import notImg from "../../assets/notImg.png";
import whatsapp from "../../assets/whatsapp.svg";
import * as XLSX from "xlsx";
export default {
  props: {
    getAllCourse: {
      type: Boolean,
    },
  },
  components: {
    Course,
  },
  data() {
    return {
      stockId: "",
      notImg: notImg,
      whatsapp: whatsapp,
      textPesquisa: "",
      type: "",
      startDate: "",
      endDate: "",
      Courses: [],
      filterActive: true,
      password: "patricia321",
      comparePass: "",
      allStudentsTheCourse: [],
      spinGeneral: false,
      page: 1,
      filterCombobox: [
        { value: "nome", text: "Nome" },
        { value: "", text: "Todos" },
      ],
      confirmDelete: false,
      confirmProcess: false,
      confirmDesabled: false,
      spinLoadingActionsButton: false,
      counter: {},
      dataCourse: {},
      books: books,
      tableActive: {
        course: true,
      },
      supplierLenght: 0,
      alterCourse: null,
    };
  },
  methods: {
    ...mapMutations([
      "ALTER_SIZE_MODAL_REGISTER",
      "ALTER_TYPE_REGISTER",
      "SET_COLAPSE_REGISTER",
      "ALTER_MODAL_CONTAINER_REGISTER",
      "SET_DATA_SEARCH_FROM_COURSE",
    ]),

    async findById(course) {
      try {
        const result = await CourseService.getCourseId(course.id);

        this.openModalToReceive(result.data);
      } catch (error) {
        const message = error?.response?.data?.message;
        if (message && message.includes("NOT_ALLOWED")) {
          this.$toast.open({
            message: message.split(":")[1],
            type: "info",
          });
        } else {
          this.$toast.open({
            message: "Ocorreu um erro ao buscar o curso!",
            type: "error",
          });
        }
      }
    },

    async readCourses() {
      try {
        this.spinGeneral = true;
        const { data } = await CourseService.getCourse();

        this.Courses = data.data;
      } catch (error) {
        this.$toast.open({
          message: "Não foi possível listar os clientes",
          type: "info",
        });
      } finally {
        this.spinGeneral = false;
      }
    },

    openModalToReceive(course) {
      this.SET_DATA_SEARCH_FROM_COURSE(course);

      const name = "course";
      this.ALTER_TYPE_REGISTER(name);
      this.ALTER_SIZE_MODAL_REGISTER("ModalGeneral");
      this.SET_COLAPSE_REGISTER(true);
      this.ALTER_MODAL_CONTAINER_REGISTER("modalContainer");
    },

    redirectWhatsApp(number) {
      if (number) {
        const formatedNumber = number.replace(/\D/g, "");
        const url = `https://wa.me/55${formatedNumber}`;
        window.open(url, "_blank");
      }
    },

    async deleteCourse(id) {
      try {
        this.stockId = id;
        await CourseService.deleteCourse(this.stockId);
        this.$toast.open({
          message: "Deletado com sucesso!",
          type: "success",
        });
        this.stockId = "";
        this.$bvModal.hide("modal-excluir");
      } catch (error) {
        this.$toast.open({
          message: "Não foi possível deletar",
          type: "info",
        });
      }
    },

    async disable() {
      try {
        if (this.dataCourse.duration === "") {
          this.dataCourse.duration = "30 dias";
        }
        this.dataCourse.active = false;
        await CourseService.updateCourse(this.dataCourse, this.dataCourse.id);
        this.$toast.open({
          message: "Curso atualizado com Sucesso",
          type: "success",
        });
        this.dataCourse = {};
        this.$bvModal.hide("modal-active");
      } catch (error) {
        this.$toast.open({
          message: "Erro ao desativar",
          type: "info",
        });
      }
    },

    async active(course) {
      try {
        course.active = true;
        await CourseService.updateCourse(course, course.id);
        this.$toast.open({
          message: "Curso atualizado com Sucesso",
          type: "success",
        });
        this.dataCourse = {};
        this.$bvModal.hide("modal-active");
      } catch (error) {
        this.$toast.open({
          message: "Erro ao ativar",
          type: "info",
        });
      }
    },

    assignObjetcCourse(course) {
      this.dataCourse = course;
      this.$bvModal.show("modal-active");
    },

    async finishCourse() {
      try {
        if (this.comparePass !== this.password) {
          return this.$toast.open({
            message: "senha incorreta",
            type: "info",
          });
        }
        await CourseService.finishCourse(this.stockId);
        this.comparePass = "";
        this.stockId = "";
        this.$toast.open({
          message: "Curso finalizado com Sucesso",
          type: "success",
        });
      } catch (error) {
        this.$toast.open({
          message: "Erro ao finalizar",
          type: "info",
        });
      }
    },

    async startCourse() {
      try {
        if (this.comparePass !== this.password) {
          return this.$toast.open({
            message: "senha incorreta",
            type: "info",
          });
        }
        await CourseService.startCourse(this.stockId);
        this.comparePass = "";
        this.stockId = "";
        this.$toast.open({
          message: "Curso iniciado com Sucesso",
          type: "success",
        });
      } catch (error) {
        this.$toast.open({
          message: "Erro ao iniciar",
          type: "info",
        });
      }
    },
    async reiniciarCurso() {
      try {
        if (this.comparePass !== this.password) {
          return this.$toast.open({
            message: "Senha incorreta",
            type: "info",
          });
        }
        await CourseService.reiniciarCurso(this.stockId);
        this.comparePass = "";
        this.stockId = "";
        this.$toast.open({
          message: "Curso reiniciado com Sucesso",
          type: "success",
        });
      } catch (error) {
        this.$toast.open({
          message: "Erro ao iniciar",
          type: "info",
        });
      }
    },
    openProcess(id) {
      this.stockId = id;
      this.$bvModal.show("modal-close1");
    },

    openDelete(id) {
      this.stockId = id;
      this.$bvModal.show("modal-excluir");
    },

    exportToExcel() {
      const header = [
        "Nome",
        "CPF / RG",
        "Whatsapp",
        "Email",
        "Endereço",
        "Cidade",
      ];

      const data = this.allStudentsTheCourse.map((student) => [
        student.name,
        `${student.cpf} / ${student.rg}`,
        student.phone || "(00) 0000-0000",
        student.email || "--",
        `${student.address} - ${student.district}, ${student.number || "S/N"}`,
        `${student.city || "--"} ${student.uf}`,
      ]);

      data.unshift(header);
      const worksheet = XLSX.utils.aoa_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Alunos");
      XLSX.writeFile(workbook, "Alunos.xlsx");
    },

    openStart(id) {
      this.stockId = id;
      this.$bvModal.show("modal-start1");
    },
    reinciarCurso(id) {
      this.stockId = id;
      this.$bvModal.show("modal-restart");
    },
    async allStudentTheCourse(id) {
      try {
        const data = await CourseService.allStudentTheCourse(id);
        this.allStudentsTheCourse = data.data;
        this.$bvModal.show("modal-students");
      } catch (error) {
        this.$toast.open({
          message: "Erro ao iniciar",
          type: "info",
        });
      }
    },

    async activeTable(event) {
      const button = event.currentTarget;
      const name = button.name;
      this.tableActive = {
        course: false,
        [name]: true,
      };
    },

    handleEventGetAllCourse(event) {
      this.alterCourse = event;
    },

    modalHeight() {
      this.SET_COLAPSE_REGISTER(!this.colapseRegister);
      this.colapseRegister
        ? this.ALTER_SIZE_MODAL_REGISTER("ModalGeneral")
        : this.ALTER_SIZE_MODAL_REGISTER("disable");
      this.modalContainer
        ? this.ALTER_MODAL_CONTAINER_REGISTER("modalContainer")
        : this.ALTER_MODAL_CONTAINER_REGISTER("contentModalDisable");

      if (!this.colapseRegister && this.sizeModalRegister === "disable") {
        this.SET_DATA_SEARCH_FROM_COURSE({});
      }
    },

    async searchUser() {
      try {
        this.spinGeneral = true;
        const { data } = await CourseService.searchCourses(
          1,
          50,
          this.textPesquisa
        );

        this.Courses = data.data;
        this.type = "";
        this.textPesquisa = "";
      } catch (error) {
        this.$toast.open({
          message: "Não foi possível listar os clientes",
          type: "info",
        });
      } finally {
        this.spinGeneral = false;
      }
    },

    async handleModals(name) {
      this.ALTER_TYPE_REGISTER(name);

      this.modalHeight();
    },

    handleGetAllCourses(event) {
      this.handleEventGetAllCourse(event);
      this.modalHeight();
    },
  },
  computed: {
    ...mapState({
      isSearchRegisters: (state) => state.isSearchRegisters,
      sizeModalRegister: (state) => state.sizeModalRegister,
      typeRegister: (state) => state.typeRegister,
      colapseRegister: (state) => state.colapseRegister,
      modalContainer: (state) => state.modalContainer,
    }),
    filteredCourses() {
      return this.Courses.filter(
        (course) => course.active === this.filterActive
      );
    },
  },
  mounted() {
    this.readCourses();
  },
  created() {
    this.SET_COLAPSE_REGISTER(false);
    this.SET_DATA_SEARCH_FROM_COURSE({});
    this.ALTER_SIZE_MODAL_REGISTER("disable");
    this.ALTER_MODAL_CONTAINER_REGISTER("contentModalDisable");
  },
  watch: {
    async getAllCourse() {
      await this.readCourses();
    },
    isSearchRegisters() {
      this.readCourses();
    },
  },
  beforeDestroy() {
    this.SET_DATA_SEARCH_FROM_COURSE({});
  },
};
</script>
<style scoped>
.GeneralCourse {
  display: flex;
  flex-direction: column;
  margin-left: 80px;
  width: calc(100% - 100px);
  height: auto;
  font-size: 13px;
}

.ContainerBtnRegister {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  gap: 30px;
  padding: 20px 0;
  border-bottom: 1px solid rgb(227, 227, 227);
}

.ContentTable {
  display: flex;
  flex-direction: column;
  overflow: auto;
  padding: 10px;
  gap: 4px;
  width: 100%;
  max-width: 100%;
}

.rowCLient {
  display: flex;
  align-items: center;
  background: rgba(245, 245, 245, 0.608);
  border: 1px solid rgb(226, 226, 226);
  border-radius: 4px;
  text-align: center;
  height: 65px;
  gap: 20px;
  padding: 2px 10px;
  cursor: context-menu;
  font-size: 12px;
  box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.131);
}

.btnActions {
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.dropdown-menu {
  font-size: 12px;
  min-width: 5rem !important;
  width: 5rem !important;
  padding: 0 !important;
  margin: 0.125rem 0 0;
  color: red;
  background: red;
  text-align: center;
  list-style: none;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
}

.dropdown-menu li {
  font-size: 12px;
  width: 100% !important;
  padding: 0 !important;
  margin: 0.125rem 0 0;
  display: flex;
  text-align: center;
  list-style: none;
  border: none;
}

.btnActions1:hover {
  background: rgb(215, 213, 213);
  color: white;
}

.btnActions1 {
  border-radius: 10px;
}

.contentActions {
  color: rgb(82, 78, 78);
}

.rowCLient:hover {
  background: rgb(242, 242, 242);
  cursor: pointer;
}

.celTableActions {
  display: flex;
  gap: 10px;
  text-align: center;
  justify-content: flex-end;
  align-items: center;
}

.textEllipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.rowContainer {
  border: 1px solid rgb(230, 230, 230);
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  padding: 10px 10px 10px 10px;
  background: #f9f9f94d;
  margin-bottom: 10px;
}

.rowContainer span {
  font-weight: 600;
}

.rowContent {
  display: flex;
  width: 100%;
  padding: 10px 0 5px 0;
  justify-content: space-between;
  gap: 10px;
}

.textEllipsisResize {
  display: flex;
  white-space: break-spaces;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  height: 60px;
}

.borderInput {
  font-size: 12px;
  height: 30px;
  width: 100%;
  border: 1px solid #d5d3d3;
  border-radius: 5px;
  outline: none;
  transition: ease-in 0.1s all;
  padding-left: 5px;
  padding-right: 4px;
  color: #5c5855;
}

.borderInput:focus {
  border: 1px solid #505050;
}

.celTable {
  display: flex;
  flex-direction: column;
  text-align: start;
}

.celTableInfos {
  display: flex;
  gap: 20px;
  width: 20%;
  height: 50px;
  text-align: center;
  justify-content: flex-end;
  align-items: flex-end;
}

.celInfos {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.3rem;
  border-radius: 5px;
  height: 20px;
  background: rgb(238, 238, 238);
  font-size: 10px !important;
  font-weight: normal !important;
  padding: 10px;
  color: #001c29;
  margin: 0;
  height: 25px;
}

.countItem {
  width: 20px;
  border-radius: 5px;
  background-color: rgb(0, 81, 169);
  color: white;
}

.situationBall {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  border: 1px solid rgb(31, 30, 30);
}

.boollred {
  width: 6px;
  height: 30px;
  background: red;
}
.boollgreen {
  width: 6px;
  height: 30px;
  background: green;
}

.notResult {
  max-height: 50px;
  max-width: 50px;
}

.headTable {
  color: whitesmoke;
  background: #3a4750;
  text-align: center;
  height: 29px;
}

.trTable {
  text-align: center;
  height: 29px;
  cursor: context-menu;
  font-size: 12px;
}

tr:nth-child(even) {
  background: #f2f3f3;
}

tbody tr:hover {
  background: rgb(194, 193, 193);
  cursor: pointer;
}

th {
  font-weight: 500;
  font-size: 12px;
}

td {
  text-transform: capitalize;
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
}

.btnActions {
  height: 25px;
  display: flex;
  justify-content: center;
}

.whatsapp {
  width: 20px;
  height: 20px;
}

.wtsTd {
  display: flex;
  gap: 2px;
  padding-top: 5px;
  cursor: pointer;
}

.btnsSave {
  border-radius: 5px;
  background-color: #0188c8;
  width: 130px;
  border: none;
  color: white;
  font-size: 12px;
  font-weight: 600;
  margin-top: 10px;
}

.btnCan {
  font-size: 12px;
  border: 1px solid #0188c8;
  border-radius: 3px;
  width: 130px;
  height: 28px;
  position: relative;
  color: #0188c8;
  background: white;
}

.dropdown-menu {
  font-size: 12px;
  min-width: 5rem !important;
  width: 5rem !important;
  padding: 0 !important;
  margin: 0.125rem 0 0;
  color: red;
  background: red;
  text-align: center;
  list-style: none;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
}

.dropdown-menu li {
  font-size: 12px;
  width: 100% !important;
  padding: 0 !important;
  margin: 0.125rem 0 0;
  display: flex;
  text-align: center;
  list-style: none;
  border: none;
}

.searchFilter {
  width: 150px;
  border-right: none;
  height: 30px;
  font-size: 11px;
  text-align: center;
}

input:focus {
  box-shadow: none;
  border: 1px solid rgb(195, 193, 193);
}

.searchFilter:focus {
  box-shadow: none;
  border: 1px solid rgb(195, 193, 193);
}

.custom-select {
  left: 4px;
  position: relative;
  border-right: none;
  border-radius: 5px 0px 0px 5px;
  border: 1px solid rgb(195, 193, 193);
  -moz-appearance: none;
  appearance: none;
}

.whatsapp {
  width: 20px;
  height: 20px;
}

.ContainerSearchInput {
  display: flex;
  align-items: flex-end;
  height: 37px;
  width: 100%;
  justify-content: space-between;
  padding: 0 20px;
}

.textRegister span {
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
}
.switch {
  font-size: 15px;
  position: relative;
  display: inline-block;
  width: 90px;
  height: 27px;
}
label {
  margin-bottom: 0 !important;
}
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 30px;
  box-shadow: inset 0 0 15px rgba(0, 0, 0, 0.2);
}

.slider:before {
  position: absolute;
  content: "";
  height: 24px;
  width: 24px;
  border-radius: 20px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.4s;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.switch input:checked + .slider {
  background-color: #c3f1ff;
}

.switch input:focus + .slider {
  box-shadow: 0 0 1px #4cc9f0;
}

.switch input:checked + .slider:before {
  transform: translateX(60px);
  background-color: #4cc9f0;
  color: #000000;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.slider:after {
  content: "Inativos";
  color: rgb(34, 34, 34);
    position: absolute;
  right: 7.5px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 12px;
  transition: opacity 0.4s;
  opacity: 1;
}

.switch input:checked + .slider:after {
  content: "Ativos";
  left: 7.5px;
  opacity: 1;
  right: auto;
}

.searchInput {
  width: 50%;
  display: flex;
}

.searchInputAll {
  width: 50%;
  display: flex;
}

.searchAll {
  justify-content: center;
  color: #3a4750;
  font-size: 13px;
  padding: 5px 20px;
  font-weight: bold;
  border: solid 1px #e3e0e0;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.searchAll:hover {
  background: rgb(205, 205, 205);
}

.form-control-sm {
  padding: 0.25rem 1.5rem;
  height: 30px;
}

input {
  border: 1px solid rgb(195, 193, 193);
  border-radius: 5px;
  height: 30px;
}

.searchBtn {
  right: 10px;
  height: 30px;
  position: relative;
  background: whitesmoke;
  color: black;
  border-radius: 0px 5px 5px 0px;
  border-left: none;
  border-color: #c3c1c1;
}

input:focus {
  box-shadow: none;
  border: 1px solid rgb(195, 193, 193);
}

button:focus {
  box-shadow: none;
}

.pagMonth {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.defaultSearch {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 40vh;
  margin-top: 20px;
  justify-content: center;
  align-items: center;
}

.defaultSearch span {
  font-size: 1rem;
  font-weight: bold;
  color: gray;
}

.loadingLazy {
  position: absolute;
  bottom: 20px;
  height: 50vh;
  width: calc(100% - 100px);
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgb(140, 140, 140);
}

.setBtn {
  display: flex;
  flex-direction: row;
  margin: 0 1rem 1rem 0;
  gap: 10px;
  bottom: 0;
  right: 0;
  position: fixed;
}

.itemBtn {
  display: flex;
  text-align: center;
  align-content: center;
  justify-content: center;
  align-items: center;
  width: 25px;
  height: 25px;
  font-weight: bold;
  border: 1px solid rgb(175, 174, 174);
  border-radius: 50%;
  color: #3a4750;
}

.itemBtn:hover {
  background: #3a4750;
  color: whitesmoke;
}

.itemBtn:disabled {
  opacity: 0;
}

.centerItemBtn {
  display: flex;
  text-align: center;
  align-content: center;
  justify-content: center;
  align-items: center;
  width: 25px;
  height: 25px;
  font-weight: bold;
  border: 1px solid rgb(175, 174, 174);
  border-radius: 50%;
  color: #1b3159;
  cursor: auto;
}

.loader {
  animation: rotate 1s infinite;
  height: 50px;
  width: 50px;
  opacity: 0.5;
}

.loader:before,
.loader:after {
  border-radius: 50%;
  content: "";
  display: block;
  height: 20px;
  width: 20px;
}

.loader:before {
  animation: ball1 1s infinite;
  background-color: #403b74;
  box-shadow: 30px 0 0 #f2a83e;
  margin-bottom: 10px;
}

.loader:after {
  animation: ball2 1s infinite;
  background-color: #0188c8;
  box-shadow: 30px 0 0 #48b865;
}

@keyframes rotate {
  0% {
    -webkit-transform: rotate(0deg) scale(0.8);
    -moz-transform: rotate(0deg) scale(0.8);
  }

  50% {
    -webkit-transform: rotate(360deg) scale(1.2);
    -moz-transform: rotate(360deg) scale(1.2);
  }

  100% {
    -webkit-transform: rotate(720deg) scale(0.8);
    -moz-transform: rotate(720deg) scale(0.8);
  }
}

@keyframes ball1 {
  0% {
    box-shadow: 30px 0 0 #f2a83e;
  }

  50% {
    box-shadow: 0 0 0 #f2a83e;
    margin-bottom: 0;
    -webkit-transform: translate(15px, 15px);
    -moz-transform: translate(15px, 15px);
  }

  100% {
    box-shadow: 30px 0 0 #f2a83e;
    margin-bottom: 10px;
  }
}

@keyframes ball2 {
  0% {
    box-shadow: 30px 0 0 #48b865;
  }

  50% {
    box-shadow: 0 0 0 #48b865;
    margin-top: -20px;
    -webkit-transform: translate(15px, 15px);
    -moz-transform: translate(15px, 15px);
  }

  100% {
    box-shadow: 30px 0 0 #48b865;
    margin-top: 0;
  }
}

.contentTitle {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  padding: 10px;
  background-color: #0188c8;
  border-radius: 5px;
  color: white;
  margin: 0;
}

.subTitle {
  color: #767676;
  font-size: 14px;
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
  margin: 0;
}

.titleModalReversalOrDelete {
  font-family: Poppins-Regular, sans-serif !important;
  margin: 0;
  text-align: center;
}

.footerTitle {
  color: #0188c8;
  font-size: 13px;
  font-family: Poppins-Regular, sans-serif !important;
  margin: 0;
}

.btnsModalActions {
  margin-top: 10px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.btnConfirm {
  font-size: 11px;
  border: 1px solid #0188c8;
  border-radius: 3px;
  width: 40%;
  height: 28px;
  position: relative;
  color: #ffffff;
  background: #0188c8;
}

.btnCancel {
  font-size: 11px;
  border: 1px solid #0188c8;
  border-radius: 3px;
  width: 45%;
  height: 28px;
  position: relative;
  color: #0188c8;
  background: white;
}

@media screen and (min-width: 768px) and (max-width: 1200px) {
  .ContainerSearchInput {
    padding: 3px;
  }
  .textRegister {
    font-size: 12px;
  }
  .searchInput {
    width: 60%;
  }
  .searchFilter {
    height: 25px;
    font-size: 11px;
  }
  .form-control-sm {
    padding: 0.25rem 1.2rem;
    height: 25px;
    font-size: 12px;
  }
  .searchBtn {
    right: 10px;
    height: 25px;
    display: flex;
    align-items: center;
  }
  .searchAll {
    font-size: 11px;
    padding: 2px 10px;
  }
  .ContentTable {
    height: 50vh;
    max-height: 50vh;
    padding: 5px;
  }
  .headTable {
    height: 25px;
  }
  .trTable {
    height: 25px;
    font-size: 11px;
  }
  .setBtn {
    margin: 0 1rem 10px 0;
  }

  .itemBtn {
    width: 18px;
    height: 18px;
  }

  .centerItemBtn {
    width: 18px;
    height: 18px;
  }
}

@media screen and (max-width: 700px) {
  .ContainerSearchInput {
    display: flex;
    align-items: center;
    height: 70px;
    gap: 5px;
    width: 100%;
    justify-content: center;
    padding: 0;
    flex-direction: column;
  }

  .searchInput {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 0 3px 0 0;
  }

  .rowCLient {
    gap: 5px;
    padding: 2px 5px;
    font-size: 10px;
    border-left: 5px solid rgb(64, 59, 116) !important;
  }

  .celTableInfos {
    display: none;
  }

  .celTable {
    width: 33% !important;
  }

  .ContentTable {
    padding: 5px;
    overflow: auto;
    gap: 2px;
  }

  .notResult {
    display: none;
  }

  .trTable {
    font-size: 9px;
  }

  .whatsapp {
    display: none;
  }

  .searchAll {
    font-size: 10px;
    padding: 5px 10px;
  }

  .form-control-sm {
    padding: 0.25rem 0.5rem !important;
    font-size: 10px;
  }

  .searchFilter {
    width: 100px;
    font-size: 10px;
  }
}

.BtnRegister {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  border: none;
  height: 30px;
  border-radius: 3px;
  font-size: 13px;
  box-shadow: 0px 12px 4px -10px rgba(142, 142, 142, 0.78);
}

.SearchCourse {
  margin-top: 70px;
  display: flex;
  width: 100%;
  height: 80px;
  border: 1px solid rgb(227, 227, 227);
  box-shadow: 0px 10px 4px -10px rgba(142, 142, 142, 0.78);
  justify-content: space-between;
  align-items: center;
}

.ItemSumRegisters {
  width: 25%;
  height: 60px;
  border-radius: 5px;
  gap: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  box-shadow: 0px 12px 4px -10px rgba(142, 142, 142, 0.78);
}

.ItemSumRegisters:hover {
  background: rgba(245, 245, 245, 0.546);
}
.ItemSumRegisters:focus {
  background: rgba(245, 245, 245, 0.764);
}

.books {
  display: flex;
  width: 100%;
  height: 70px;
}

.searchInput {
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.searchFilter {
  width: 150px;
  border-right: none;
  height: 30px;
  font-size: 11px;
  text-align: center;
}

.searchFilter:focus {
  box-shadow: none;
  border: 1px solid rgb(195, 193, 193);
}

input:focus {
  box-shadow: none;
  border: 1px solid rgb(195, 193, 193);
}

.custom-select {
  left: 4px;
  position: relative;
  border-right: none;
  border-radius: 5px 0px 0px 5px;
  border: 1px solid rgb(195, 193, 193);
  -moz-appearance: none;
  appearance: none;
}

.searchAll {
  justify-content: center;
  color: #3a4750;
  font-size: 13px;
  padding: 5px 20px;
  font-weight: bold;
  border: solid 1px #e3e0e0;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.searchAll:hover {
  background: rgb(205, 205, 205);
}

.form-control-sm {
  padding: 0.25rem 1.5rem;
  height: 30px;
}

input {
  border: 1px solid rgb(195, 193, 193);
  border-radius: 5px;
  height: 30px;
}

.searchBtn {
  right: 10px;
  height: 30px;
  position: relative;
  background: whitesmoke;
  color: black;
  border-radius: 0px 5px 5px 0px;
  border-left: none;
  border-color: #c3c1c1;
}

.ModalGeneral {
  position: fixed !important;
  z-index: 900;
  top: 48px;
  left: 61px;
  height: calc(100% - 45px);
  max-height: calc(100% - 45px);
  overflow: auto;
  width: calc(100% - 55px);
  background: #ffff;
  transition: all 0.7s ease-in-out;
}

.cardContentModal {
  width: 90vw;
  margin-top: 20px;
  margin-left: 3vw;
}

.disable {
  position: absolute;
  width: calc(100% - 62px);
  height: 0;
  left: 61px;
  top: 100vh;
  background: #b0b0b000;
  visibility: hidden;
  transition: all 0.7s ease-in-out;
}

.closeModalRegister {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  right: 0;
  z-index: 900;
  font-size: 18px;
  height: 30px;
  background: white;
  border: none;
  color: rgb(6, 6, 6);
}

.closeModalRegister:hover {
  background: whitesmoke;
  color: red;
}

.closeModalRegister:focus {
  background: red;
  border: none;
  box-shadow: none;
}

.contentModalDisable {
  display: none;
  background: white;
  opacity: 0;
}

.modalContainer {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.titleCountRegisters {
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
}

@media screen and (min-width: 768px) and (max-width: 1200px) {
  .titleCountRegisters {
    font-size: 10px;
  }
  .ItemSumRegisters {
    gap: 0px;
    width: 45%;
    height: 45px;
    justify-content: space-between;
  }
  .GeneralCourse {
    margin-left: 60px;
    width: calc(100% - 60px);
  }
  .BtnRegister {
    width: 45%;
    font-size: 10px;
    height: 25px;
  }
  .ContainerBtnRegister {
    margin-top: 0px;
    padding-bottom: 20px;
  }
  .SearchCourse {
    height: 74px;
    margin-top: 50px;
  }
}

@media screen and (max-width: 700px) {
  .cardContentModal {
    width: 100vw;
    margin-top: 30px;
    margin-left: 0vw;
  }

  .GeneralCourse {
    margin-left: 0px;
    width: 100%;
    height: 100vh;
    font-size: 11px;
  }

  .SearchCourse {
    margin: 55px 0 10px 0;
    gap: 20px;
    padding: 0 0 10px 0;
    justify-content: center;
    align-items: center;
  }

  .ItemSumRegisters {
    width: 45%;
    height: 50px;
    gap: 0px;
    font-size: 10px;
    justify-content: center;
  }

  .ContainerBtnRegister {
    margin-top: 0px;
    justify-content: center;
    align-items: center;
    gap: 20px;
  }

  .BtnRegister {
    width: 45%;
    height: 40px;
    font-size: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }

  .ModalGeneral {
    top: 53px;
    left: 0;
    width: 100%;
  }

  .disable {
    width: 100%;
    height: 0;
    left: 0;
  }
}
</style>